// extracted by mini-css-extract-plugin
module.exports = {"title":"e_2i","container":"e_3i","right":"e_4i","image":"e_5i","scoreLine":"e_6i","scoreRing":"e_7i","badge":"e_8i","badgeImage":"e_9i","badgeRing":"e_-i","large":"e_aj"};